import hasProp from "./hasProp";

export default {
  hasProp
};
